import { render, staticRenderFns } from "./VendorRegister-2.vue?vue&type=template&id=1bee1d75&scoped=true"
import script from "./VendorRegister-2.vue?vue&type=script&lang=js"
export * from "./VendorRegister-2.vue?vue&type=script&lang=js"
import style0 from "./VendorRegister-2.vue?vue&type=style&index=0&id=1bee1d75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bee1d75",
  null
  
)

export default component.exports